import {createAction} from 'redux-actions';
import {batchActions} from 'redux-batched-actions';
import {setTextTemplatesGroup, setTheme, setThemeGroup} from "../create-llama/actions";
import * as Noty from 'noty';

const namespace = 'DICTIONARIES';

export const loadThemesRequest = createAction(`${namespace}/LOAD_THEMES_REQUEST`);
export const loadThemesSuccess = createAction(`${namespace}/LOAD_THEMES_SUCCESS`);
export const loadThemesFailed = createAction(`${namespace}/LOAD_THEMES_FAILED`);

export const loadTextsTemplatesRequest = createAction(`${namespace}/LOAD_TEMPLATE_TEXTS_REQUEST`);
export const loadTextsTemplatesSuccess = createAction(`${namespace}/LOAD_TEMPLATE_TEXTS_SUCCESS`);
export const loadTextsTemplatesFailed = createAction(`${namespace}/LOAD_TEMPLATE_TEXTS_FAILED`);

import themeDictionary from "../../domain/dictionaries/ThemeDictionary";
import greetingsDictionary from "../../domain/dictionaries/GreetingsDictionary";

// Сделано для того чтобы, не зависеть от раздельной или совместной загрузки
export function loadDictionaries() {
    return (dispatch, getState) => {

        // load and set Themes
        dispatch(loadThemesRequest());
        themeDictionary.get()
            .then(({groups, templates}) => {
                let firstThemeGroup;
                let firstTheme;
                // TODO: THIS IS A TEMP FIX - we need to move sorting to 1 place as this is done in "createLlamaActiveGroupThemesSelector" selector
                try {
                    const firstThemeGroupId = "1";
                    firstThemeGroup = groups.find((group) => group.id.toString() === firstThemeGroupId);
                    firstTheme = templates
                        .filter((theme) => Object.keys(theme.group_ids).some((id) => id === firstThemeGroupId))
                        .sort((a, b) => a.group_ids[firstThemeGroupId] - b.group_ids[firstThemeGroupId])[0];
                } catch {
                    // continue
                }
                //  TODO: This is the fallback
                if (!firstTheme || !firstThemeGroup) {
                    firstTheme = templates[0];
                    firstThemeGroup = groups.find((group) => Object.keys(firstTheme.group_ids).some((id) => id == group.id));
                }
                dispatch(batchActions([
                    loadThemesSuccess({
                        groups,
                        templates,
                        defaultThemeGroup: firstThemeGroup,
                        defaultThemeTemplate: firstTheme
                    }),
                    // set default themes, groups on sticker form
                    setThemeGroup(firstThemeGroup),
                    setTheme(firstTheme),
                ]));
            }).catch((error) => {
            showErrorMessage(error);
            dispatch(loadThemesFailed(error));
        });

        // load and set Text templates
        dispatch(loadTextsTemplatesRequest());
        greetingsDictionary.get()
            .then(({groups, templates}) => {
                const firstTextTemplates = templates[0];
                const firstTextTemplateGroup = groups.find((group) => Object.keys(firstTextTemplates.group_ids).some((id) => id == group.id));
                dispatch(batchActions([
                    loadTextsTemplatesSuccess({templates, groups, defaultTextTemplatesGroup: firstTextTemplateGroup}),
                    setTextTemplatesGroup(firstTextTemplateGroup)
                ]));
            }).catch((error) => {
            showErrorMessage(error);
            dispatch(loadTextsTemplatesFailed(error));
        })
    };
}

function showErrorMessage(error) {
    new Noty({
        type: 'error',
        timeout: 3000,
        text: `Dictionaries load failed. ${error}`,
    }).show();
}



// WEBPACK FOOTER //
// ./src/app/modules/stickers/store/dictionaries/actions.ts